$(".selected-options").click(function (event) {
    $(".selectors-popup").toggleClass("active");
    $("body").toggleClass("lang-menu-open");
    event.stopPropagation();
})
$(".selectors-popup").click(function (event) {
    event.stopPropagation();
})
$(document).on("click", "body.lang-menu-open", function (event) {
    if (!($(event.target).hasClass("selected-options")) && !($(event.target).hasClass("selectors-popup"))) {
        $(".selectors-popup").removeClass("active");
        $("body").removeClass("lang-menu-open");
    }

})
